export default "__VITE_ASSET__DjDDoUU2__"